import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/software-controlbar/warn.png'


_pushScopeId("data-v-5a3a8ea9")
const _hoisted_1 = {
  key: 0,
  class: "software-control-bar"
}
const _hoisted_2 = { class: "cloaseAll-content" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 是否退出程序？ ")
_popScopeId()

import { ref } from "vue";


export default _defineComponent({
  setup(__props) {

const electron = window.require ? window.require("electron") : null;
const isFullScreen = ref(true);
const closeAllStatus = ref(false);
const minimize = () => {
  if (electron) {
    const win = electron.remote.getCurrentWindow();
    win.minimize();
  }
};
const maximize = () => {
  if (electron) {
    const win = electron.remote.getCurrentWindow();
    if (isFullScreen.value) {
      fullScreen(false);
    }
    win.maximize();
  }
};
const fullScreen = ($isFullScreen: boolean) => {
  if (electron) {
    const win = electron.remote.getCurrentWindow();
    win.setFullScreen($isFullScreen);
    isFullScreen.value = $isFullScreen;
  }
};

const close = async () => {
  if (electron) {
    const remote = electron.remote;
    const ipcRenderer = electron.ipcRenderer;
    await ipcRenderer.invoke("closeLocalWebSiteServer");
    if (process.platform === "win32") {
      const ppid = process.ppid;
      if (ppid) {
        process.kill(ppid);
      } else {
        remote.app.exit();
      }
    } else {
      remote.app.exit();
    }
    remote.app.exit();
  }
};

return (_ctx: any,_cache: any) => {
  return (_unref(electron))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "control-item minimize",
          onClick: minimize
        }),
        _createElementVNode("div", {
          class: "control-item close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (closeAllStatus.value = true))
        }),
        _createElementVNode("div", {
          class: "app-closeAll-bg",
          style: _normalizeStyle([closeAllStatus.value ? '' : 'display:none'])
        }, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _hoisted_4,
            _createElementVNode("button", {
              style: {"margin-left":"30px"},
              onClick: _cache[1] || (_cache[1] = ($event: any) => (closeAllStatus.value = false))
            }, " 取消 "),
            _createElementVNode("button", { onClick: close }, "退出")
          ])
        ], 4)
      ]))
    : _createCommentVNode("", true)
}
}

})